import type { ChangeEventHandler } from "react";

import { RadioButton } from "@jti/core-components";
import { Tooltip } from "@jti/ui";

import styles from "./PaymentMethod.module.scss";

type PaymenMethodProps = {
  code: string;
  title: string;
  icon?: string;
  tooltip?: string;
  tokenizable: boolean;
  isSubscription: boolean;
  isFreeTrial: boolean;
  isEnabled?: boolean;
  name?: string;
  checked?: boolean;
  onChange?: ChangeEventHandler<HTMLInputElement>;
};

const PaymentMethod = ({
  code,
  icon,
  title,
  tooltip,
  tokenizable,
  isSubscription,
  isFreeTrial,
  isEnabled,
  name = "code",
  checked,
  onChange,
}: PaymenMethodProps) => {
  const isDisabled = !isEnabled || ((isSubscription || isFreeTrial) && !tokenizable);

  return (
    <div key={code} className={styles.paymentMethodItem} data-testid={`payment-method-${code}`}>
      <div className={styles.paymentMethodControl}>
        <RadioButton
          name={name}
          value={code}
          checked={checked}
          disabled={isDisabled}
          onChange={onChange}
          data-testid={`payment-method-${code}-radio`}
          label={
            <>
              {title}
              {!!tooltip && <Tooltip content={<span>{tooltip}</span>} wrapperClassName={styles.popoverIcon} />}
            </>
          }
        />
      </div>
      {icon && <img src={icon} alt="" className={styles.paymentMethodImg} />}
    </div>
  );
};

export default PaymentMethod;
